import shortenUrl from "./shortenUrl.js";
export default shortenUrl;
